/**
 * @generated SignedSource<<d9a93249d83f5d22e3d30116baea0fe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StemBalanceResponse",
    "kind": "LinkedField",
    "name": "getBalanceByLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmPaymentGetBalanceByLabelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "confirmPaymentGetBalanceByLabelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f642782b5b4fc819366ad9382edd312e",
    "id": null,
    "metadata": {},
    "name": "confirmPaymentGetBalanceByLabelQuery",
    "operationKind": "query",
    "text": "query confirmPaymentGetBalanceByLabelQuery {\n  getBalanceByLabel {\n    balance\n  }\n}\n"
  }
};
})();

node.hash = "ec1cb5a4f2704d3b55bb66244b0022ee";

module.exports = node;
